import axios from "axios";

export const deleteIndicatorExplanation = ({ owner, id }) => {
  const requestUrl = `/data/indicator-explanation/delete`;

  let formData = new FormData();
  formData.append("owner", owner);
  formData.append("id", id);

  return axios.post(requestUrl, formData);
};

export const getIndicatorsExplanation = ({ uen, token }) => {
  const requestUrl = `/data/indicators-explanation`;
  let params = {
    owner: uen,
    access_token: token
  };

  return axios.get(requestUrl, {
    params
  });
};

export const saveIndicatorsExplanation = ({
  owner,
  indicatorExplanationId,
  selectedAccount,
  contents
}) => {
  const requestUrl = `/data/save/indicator-explanation`;

  let formData = new FormData();
  formData.append("owner", owner);
  indicatorExplanationId &&
    formData.append("indicatorExplanationId", indicatorExplanationId);
  formData.append("target", selectedAccount);
  formData.append("contentFr", contents.fr);
  formData.append("contentEn", contents.en);
  formData.append("contentNl", contents.nl);

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/indicatorsExplanation.js